import React from "react";
import Icon from "components/AppIcon";

const sectorMeta = {
  retail: { icon: "ShoppingCart", color: "var(--color-primary)", label: "Retail" },
  tech: { icon: "Cpu", color: "#A78BFA", label: "Technology" },
  manufacturing: { icon: "Factory", color: "var(--color-accent)", label: "Manufacturing" },
  financial: { icon: "Landmark", color: "var(--color-success)", label: "Financial" },
  black_market: { icon: "Skull", color: "var(--color-error)", label: "Black Market" },
};

const SectorSummary = ({ businesses }) => {
  const sectorStats = businesses?.reduce((acc, b) => {
    if (!acc?.[b?.sector]) acc[b.sector] = { count: 0, revenue: 0, cost: 0 };
    acc[b.sector].count += 1;
    acc[b.sector].revenue += b?.revenue;
    acc[b.sector].cost += b?.operatingCost;
    return acc;
  }, {});

  const totalRevenue = businesses?.reduce((s, b) => s + b?.revenue, 0);
  const totalCost = businesses?.reduce((s, b) => s + b?.operatingCost, 0);
  const totalNet = totalRevenue - totalCost;

  return (
    <div className="rounded-xl border p-4 md:p-5" style={{ background: "var(--color-card)", borderColor: "var(--color-border)" }}>
      <div className="flex items-center gap-2 mb-4">
        <Icon name="PieChart" size={16} color="var(--color-primary)" />
        <h3 className="font-heading text-sm font-semibold text-foreground">Sector Overview</h3>
      </div>
      {/* Total Summary */}
      <div className="grid grid-cols-3 gap-2 mb-4">
        {[
          { label: "Total Revenue", value: `$${totalRevenue?.toLocaleString()}`, color: "var(--color-success)" },
          { label: "Total Costs", value: `$${totalCost?.toLocaleString()}`, color: "var(--color-error)" },
          { label: "Net Income", value: `$${totalNet?.toLocaleString()}`, color: totalNet >= 0 ? "var(--color-success)" : "var(--color-error)" },
        ]?.map(item => (
          <div key={item?.label} className="rounded-lg p-2.5 text-center" style={{ background: "rgba(255,255,255,0.03)" }}>
            <div className="font-caption text-xs text-muted-foreground mb-1">{item?.label}</div>
            <div className="font-heading text-xs md:text-sm font-bold" style={{ color: item?.color }}>{item?.value}</div>
          </div>
        ))}
      </div>
      {/* Per Sector */}
      <div className="space-y-2">
        {Object.entries(sectorStats)?.map(([sector, stats]) => {
          const meta = sectorMeta?.[sector];
          const net = stats?.revenue - stats?.cost;
          const share = totalRevenue > 0 ? (stats?.revenue / totalRevenue * 100)?.toFixed(0) : 0;
          return (
            <div key={sector} className="flex items-center gap-3 p-2.5 rounded-lg" style={{ background: "rgba(255,255,255,0.02)" }}>
              <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{ background: `${meta.color}15` }}>
                <Icon name={meta.icon} size={13} color={meta.color} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <span className="font-caption text-xs text-foreground">{meta.label}</span>
                  <span className="font-caption text-xs" style={{ color: net >= 0 ? "var(--color-success)" : "var(--color-error)" }}>
                    ${net?.toLocaleString()}
                  </span>
                </div>
                <div className="h-1 rounded-full bg-muted overflow-hidden">
                  <div className="h-full rounded-full transition-all duration-500" style={{ width: `${share}%`, background: meta.color }} />
                </div>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="font-caption text-xs text-muted-foreground">{stats?.count} biz</div>
                <div className="font-caption text-xs" style={{ color: meta.color }}>{share}%</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SectorSummary;